export const APP_NAMES = {
  VPAAS: 'VPAAS',
  MEET: 'MEET'
}

export const BASE_DOMAIN = window.location.hostname
  .split('.')
  .slice(-2)
  .join('.')

export const KEY_CODES = {
  ENTER: 13
}

export const PLAN_TYPES = {
  PRO: 'PRO',
  FREE: 'FREE'
}

export const PRODUCT_ADVERTISED_FEATURES = {
  BRANDING_SUPPORT: 'feature_branding_support',
  CALENDAR_SYNC: 'feature_calendar_sync',
  ENCRYPTION_SUPPORT: 'feature_encryption_support',
  HIGH_RELIABILITY: 'feature_high_reliability',
  MODERATION_SUPPORT: 'feature_moderation_support',
  PASSWORD_PROTECTION: 'feature_password_protection',
  PERSONAL_MEETING_OWNERSHIP: 'feature_personal_meeting',
  RESOURCE_STORAGE: 'feature_resource_storage',
  TEAM_MANAGEMENT: 'feature_team_management',
  TRANSCRIPTIONS_SUPPORT: 'feature_transcriptions'
}

export const ROLES = {
  ADMIN: 'ADMIN'
}

export const APP_REDIRECT_TIMEOUT = 6000
export const CONTACT_LINK = 'https://www.8x8.com/products/apis/video#contact-us'
export const COOKIES_POLICY_URL = 'https://www.8x8.com/terms-and-conditions/cookies'
export const COUNTRIES_WITH_ZIP_TAX = ['CA', 'GB', 'US']
export const DID_STORAGE_NAME = '__AMDID'
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const EXPIRED_SUBSCRIPTION_STATUSES = ['INCOMPLETE_EXPIRED', 'UNPAID']
export const JAAS_TERMS_AND_CONDITIONS = 'https://www.8x8.com/cpaas-order-terms/jaas-module'
export const LANDING_PAGE_WIDTH = '1128px'
export const MAX_MOBILE_THRESHOLD = '767px'
export const MAX_TABLET_THRESHOLD = '1100px'
export const MIN_DESKTOP_THRESHOLD = '1176px'
export const PRIVACY_POLICY_URL = 'https://app.8x8.vc/privacy-policy'
export const TEN_YEARS_MSEC = 10 * 365.25 * 24 * 60 * 60 * 1000
export const TERMS_AND_CONDITIONS = 'https://app.8x8.vc/terms-and-conditions'
export const UNPAID_INVOICES = ['DRAFT', 'UNCOLLECTIBLE', 'OPEN']
